import styled from 'styled-components';
import config from '../../../config';
const { desktopMinWidth } = config;

export const PageLayout = styled.div`
  width: auto;
  height: 100vh;
  display: flex;
  align-items: center;
  text-align: center;
`;

export const GridLayout = styled.div`
  height: 100%;
  width: 100%;
  padding: 0 24px;
  /* PC 화면 */
  @media only screen and (min-width: ${desktopMinWidth}) {
    width: 1168px;
    height: auto;
    display: grid;
    grid-template-columns: repeat(8, 132px);
    grid-column-gap: 16px;
    margin: 0 auto;
    padding: 0 16px;
  }
`;

/**
 * Coinplug logo container
 */
export const LogoContainer = styled.div`
  margin-top: 56px;
  /* PC 화면 */
  @media only screen and (min-width: ${desktopMinWidth}) {
    margin-top: 32px;
    grid-column: 4 / 6;
  }
`;

/**
 * Coinplug logo style
 */
export const Logo = styled.img`
  height: 24px;
`;

export const IconContainer = styled.div`
  margin-top: 120px;
  grid-column: 4 / 6;
`;

export const Icon = styled.img`
  width: 160px;
  height: 160px;
  /* --error-svg-filter 는 public/index.html 에 정의되어 있음 */
  filter: var(--error-svg-filter);
`;

export const Paragraph = styled.div`
  /* var(--font) 는 public/index.html 에 정의되어 있음 */
  font-family: var(--font);
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 48px;
  /* PC 화면 */
  @media only screen and (min-width: ${desktopMinWidth}) {
    font-size: 24px;
    grid-column: 2 / 8;
  }
`;

export const BackButtonContainer = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  margin-bottom: 32px;
  /* PC 화면 */
  @media only screen and (min-width: ${desktopMinWidth}) {
    display: block;
    position: relative;
    margin-top: 74px;
    margin-bottom: 32px;
    grid-column: 4 / 6;
  }
`;

export const BackButtonWrapper = styled.div`
  padding: 0 24px;
  /* PC 화면 */
  @media only screen and (min-width: ${desktopMinWidth}) {
    padding: 0;
  }
`;

export const BackButton = styled.button`
  position: relative;

  color: #ffffff;
  background-color: #416AB1;

  cursor: pointer;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  
  height: 52px;
  width: 100%;
  border-radius: 32px;

  /* var(--font) 는 public/index.html 에 정의되어 있음 */
  font-family: var(--font);
  font-weight: 400;
  font-size: 24px;
  /* PC 화면 */
  @media only screen and (min-width: ${desktopMinWidth}) {
    width: 212px;
    margin: 0;
  }
`;